module.exports = __webpack_public_path__ + "img/about_production.a247dc1c.png";